/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'telegram-purple': {
    width: 16,
    height: 17,
    viewBox: '0 0 16 17',
    data:
      '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M1.962 7.668c3.759-1.694 6.264-2.81 7.518-3.35 3.58-1.54 4.324-1.807 4.81-1.816.106-.002.344.025.499.155.13.11.166.257.183.361.017.104.039.34.022.525-.194 2.108-1.034 7.225-1.46 9.586-.182 1-.537 1.334-.882 1.367-.748.071-1.317-.512-2.042-1.003-1.135-.77-1.776-1.248-2.877-1.999-1.273-.867-.448-1.344.278-2.124.19-.203 3.488-3.307 3.552-3.588.008-.035.015-.166-.06-.236-.075-.07-.187-.045-.267-.027-.114.027-1.926 1.266-5.438 3.718-.514.365-.98.543-1.398.534-.46-.01-1.345-.27-2.004-.49-.807-.272-1.448-.416-1.393-.876.03-.24.35-.486.96-.737z" _fill="#A363FF"/>'
  }
})
